import React from 'react';

interface JoinMovementCardProps {
  onJoinClick: () => void;
}

const JoinMovementCard: React.FC<JoinMovementCardProps> = ({ onJoinClick }) => {
  return (
    <div className="absolute left-1/2 transform -translate-x-1/2 z-20 backdrop-blur-[3px] backdrop-filter bg-[rgba(248,246,242,0.85)] p-4 md:p-5 lg:p-6 mx-4 w-[calc(100%-2rem)] md:w-auto max-w-[1000px] lg:max-w-[1200px] rounded-lg shadow-lg">
      <div className="flex flex-col gap-3 md:gap-4 items-center justify-center text-center">
        <h2 className="font-['Ovo',_serif] text-[#1f1f1f] text-[24px] md:text-[32px] lg:text-[40px] xl:text-[44px] uppercase leading-tight">
          JOIN THE MOVEMENT
        </h2>

        <p className="font-['Ovo',_serif] font-normal text-[#1f1f1f] text-[14px] md:text-[16px] lg:text-[18px] leading-relaxed max-w-[800px]">
          Join a growing movement that celebrates integrity and elevates excellence. CLOUT is more
          than a score-it's a trusted community of providers committed to excellence in aesthetics.
        </p>

        <button
          className="border-2 border-[#1f1f1f] border-solid px-6 md:px-8 lg:px-10 py-2 md:py-3 font-['Ovo',_serif] text-[#1f1f1f] text-[14px] md:text-[16px] lg:text-[18px] uppercase bg-transparent hover:bg-[#1f1f1f] hover:text-white transition-all duration-300 cursor-pointer rounded-md font-semibold tracking-wide"
          onClick={onJoinClick}
        >
          JOIN THE MOVEMENT
        </button>
      </div>
    </div>
  );
};

export default JoinMovementCard;
